import { Link } from "react-router-dom";

interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

export function Button({
  children,
  href,
  variant = "primary",
  size = "md",
  className = "",
  onClick,
  type = "button",
  disabled = false,
}: ButtonProps) {
  const base =
    "inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full whitespace-nowrap";

  const variants = {
    primary: "bg-charcoal text-warm-white hover:bg-amber-dark",
    secondary:
      "border border-warm-white/40 text-warm-white hover:border-amber hover:text-amber-dark bg-transparent backdrop-blur-sm",
    outline:
      "border-2 border-charcoal text-charcoal hover:bg-charcoal hover:text-warm-white bg-transparent",
    ghost: "text-graphite hover:text-amber-dark bg-transparent",
  };

  const sizes = {
    sm: "px-4 py-2 text-xs gap-1.5",
    md: "px-6 py-2.5 text-sm gap-2",
    lg: "px-8 py-3.5 text-base gap-2.5",
  };

  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;

  if (href) {
    return (
      <Link to={href} className={cls}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={cls} disabled={disabled}>
      {children}
    </button>
  );
}
